
import { VMain } from "vuetify/lib";

export default VMain.extend({});
